import api from '@/sui/api/denominators'
import convert from '@/sui/data/sheets/convert'
import ice from '@/sui/tools/ice'

const state = {
  edit: null
}

const getters = {
  edit: state => {
    if (state.edit == null) {
      return null
    }

    return convert.serverToClient(state.edit)
  }
}

const actions = {
  add ({ dispatch }, data) {
    return api.add(data)
  },

  update ({ dispatch }, data) {
    return api.update(data)
  },

  edit ({ commit }, data) {
    commit('reset')
    const type = 'denominators'
    return api.get(data).then((response) => {
      const { v, err } = response.data
      if (err == null && v != null) {
        v.t = type
        v.y = data.y
        if (v.sv !== data.s) {
          delete v.id
        }
        commit('setEdit', v)
      } else {
        commit('empty', data.y)
      }

      return response
    })
  },

  status ({ dispatch }, data) {
    return api.status(data)
  }
}

const mutations = {
  empty (state, y) {
    const v = { t: 'denominators', f: {}, y: y }
    state.edit = v
  },

  reset (state) {
    state.edit = null
  },

  setEdit (state, edit) {
    state.edit = ice.freeze(edit)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
